// extracted by mini-css-extract-plugin
export var legendIndicator = "_d5-1";
export var legendRight = "_d5-0";